import { useState } from "react";
import {
  connectParams,
  abstractConnect,
  redirectAfterConnect,
} from "./ta_connect";
import { constants } from "./constants";
import i18n from "./i18n";
import FCLoggger from "../../fclogger";
import { isEmpty } from "../../vendor/lodash";
import oAuthAPIInstance from "./OAuthAPI_Producer";
import { getRemoteServer } from "./configResolver";

export function LogonComponent({ basePath, errorMessage }) {
  const [fcUserName, setUserName] = useState("");
  const [fcPassword, setPassword] = useState("");
  const [errorVisible, setErrorVisible] = useState(!isEmpty(errorMessage));
  const [errorText, setErrorText] = useState(errorMessage);

  console.info(`Logon component initializing`);
  const login = async (e) => {
    e.preventDefault();
    FCLoggger.info(
      `Logging in with standard mechanism for user : ${fcUserName}`
    );
    // capture form values and merge them with existing config
    const collected = { username: fcUserName, password: fcPassword };
    const params = connectParams(getRemoteServer(), collected);

    try {
      let connectionResult = await abstractConnect(basePath, params);
      if (typeof connectionResult?.connectionKey == "string") {
        redirectAfterConnect(connectionResult.connectionKey);
      } else {
        setErrorText(connectionResult.error);
        setErrorVisible(true);
      }
    } catch (error) {
      console.error(`error caught : ${error.message}`);
      setErrorText(error.message);
      setErrorVisible(true);
    }
  };

  const getOAuthLoginBtn = (config) => (
    <button
      className={config.buttonClass}
      key={config.clientId}
      onClick={handleOpenIDLogin(config)}
    >
      {config.buttonLabel}
    </button>
  );

  return (
    <div class="col-xs-6 col-xs-offset-3">
      <div id="loginPanel" class="panel panel-default">
        <div class="panel-body">
          <img
            className="center-block"
            id="logo"
            src="./images/filecatalyst_small.png"
          />

          {errorVisible && (
            <div class="alert alert-danger" id="errorBox">
              {errorText}
            </div>
          )}

          <form id="fc_login" onSubmit={login}>
            <div className="form-group">
              <label htmlFor="username">{i18n.t("common.userNameLabel")}</label>
              <input
                type="text"
                className="form-control"
                id="username"
                name="username"
                placeholder="Username"
                onInput={(e) => setUserName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">{i18n.t("common.passwordLabel")}</label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                placeholder="Password"
                onInput={(e) => setPassword(e.target.value)}
              />
            </div>
            <div>
              <button
                className="btn btn-primary btn-block"
                id="fcSubmit"
                type="submit"
              >
                {i18n.t("common.signIn")}
              </button>
            </div>
            {oAuthAPIInstance && <div class="text-center divider">OR</div>}
            {oAuthAPIInstance && (
              <div>
                {OAuthConfigs.map((config) => getOAuthLoginBtn(config))}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );

  function handleOpenIDLogin(config) {
    return (e) => {
      e.preventDefault();
      window.sessionStorage.setItem(constants.oidcClientId, config.clientId);
      oAuthAPIInstance.login(config.clientId).catch((error) => {
        setErrorText(extractOAuthAPIErrorMessage(error));
        setErrorVisible(true);
      });
    };
  }
}

function extractOAuthAPIErrorMessage(error) {
  if (error?.message) {
    return error.name?.includes("AuthSdkError") ||
      error.name.includes("AuthApiError")
      ? i18n.t("common.oauth.apiError", { errMsg: error.message })
      : error.message;
  } else {
    return i18n.t("common.oauth.emptyError");
  }
}
